
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import AuditingFilter from '@/components/auditing/AuditingFilter.vue';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { Venue } from '@/interfaces/models/Venue';
import { Auditing } from '@/interfaces/models/Auditing';
import headers from './headers';

@Component({
  components: { VTable, AuditingFilter },
})
export default class AuditingTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Auditing[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public headers: ColumnHeader[] = headers;

  public getVenueName(venueId: string): string {
    if (!venueId) {
      return '';
    }

    const venue = this.venues.find((v: Venue) => v._id === venueId);

    return venue ? venue.name : venueId;
  }
}
